import moment from 'moment'

export type Duration = {
  hours: number
  minutes: number | undefined
}

export const momentToDuration = (value: moment.Duration): Duration => ({
  hours: Math.floor(value.asHours()),
  minutes: value.minutes(),
})

export const hoursToDuration = (hours: number): Duration => {
  const duration = moment.duration(hours, 'hours')
  return momentToDuration(duration)
}
